export default () => {
  return {
    Reports: [ 'Date_SalesReport', 'Date_IncomeStatsReport', 'Date_DespatchReport', 'Date_ABCAnalysisReport', 'Date_WasteReport' ],
    Purchasing: [ 'Date_Despatch', 'Date_Invoice', 'Date_Return', 'Date_Payment', 'Date_DirectRequest', 'Date_Request', 'Date_Order', 'Date_OrderDespatch' ],
    CostControl: [ 'Date_SuspendTransaction', 'Date_Production', 'Date_RawMaterialPlanning' ],
    StockItemTransaction: [ 'Date_StockItemTransactionReport', 'Date_Transfer' ]
  }
}
